// The phase SVG URL contains the exact revision selected for the production order.
export function programReference(file, article) {
    if (!article || !file?.programma || !file.svg) return null;
    try {
        const path = decodeURIComponent(String(file.svg).split(/[?#]/)[0]);
        const prefix = `/dxfsvg/${article[0]}/${article}/_SVG/`;
        const suffix = `.${file.programma}.svg`;
        if (!path.startsWith(prefix) || !path.endsWith(suffix)) return null;
        const version = path.slice(prefix.length, -suffix.length);
        if (!/^\d+$/.test(version)) return null;
        return { article, program: file.programma, version };
    } catch { return null; }
}
